import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import { UIActionModal } from "../../../ui";

const StartEvaluationRoundModal = ({ open, copy, onClose, onConfirm }) => (
  <UIActionModal
    open={open}
    title={copy.title}
    onClose={onClose}
    showIcon
    variant="approve"
    maxWidth="sm"
    actions={
      <UIActionModal.Actions
        cancelLabel={copy.cancel}
        confirmLabel={copy.confirm}
        confirmVariant="approve"
        onCancel={onClose}
        onConfirm={onConfirm}
      />
    }
  >
    <UIActionModal.Divider />
    <Typography className="ui-action-modal__body-text">
      {copy.message}
    </Typography>
  </UIActionModal>
);

StartEvaluationRoundModal.propTypes = {
  open: PropTypes.bool.isRequired,
  copy: PropTypes.shape({
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    cancel: PropTypes.string.isRequired,
    confirm: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default StartEvaluationRoundModal;
